<template>
    <div class="maintenance-page d-flex vh-100 align-items-center justify-content-center">
        <div class="text-center p-5">
            <h1 class="maintenance-title mb-4">Mentenanță</h1>
            <p class="maintenance-message">
                {{ displayMessage }}
            </p>
            <p v-if="windowLabel" class="maintenance-schedule text-muted mt-3">
                Interval: {{ windowLabel }}
            </p>
            <p class="maintenance-schedule mt-4">
                După finalizare veți fi redirecționat la autentificare pentru a reîncărca datele.
            </p>
        </div>
    </div>
</template>

<script>
import { checkMaintenanceMode, getMaintenanceCache, formatMaintenanceTime } from "@/utils/utils";

const DEFAULT_MESSAGE =
    "În acest moment se efectuează lucrări de mentenanță. Platforma este temporar indisponibilă. Vă rugăm reveniți după finalizarea lucrărilor și autentificați-vă din nou.";

export default {
    name: "MaintenancePage",
    data() {
        return {
            message: "",
            scheduledAt: null,
            endsAt: null,
            pollInterval: null,
        };
    },
    computed: {
        displayMessage() {
            return this.message || DEFAULT_MESSAGE;
        },
        windowLabel() {
            const start = formatMaintenanceTime(this.scheduledAt);
            const end = formatMaintenanceTime(this.endsAt);
            if (start && end) return `${start} – ${end}`;
            return start || end || "";
        },
    },
    async created() {
        await this.refreshStatus();
        this.pollInterval = setInterval(this.refreshStatus, 10000);
    },
    beforeUnmount() {
        if (this.pollInterval) {
            clearInterval(this.pollInterval);
        }
    },
    methods: {
        async refreshStatus() {
            const data = await checkMaintenanceMode({
                showWarningConfirm: false,
            });
            const cache = data || getMaintenanceCache();
            this.message = cache.message || "";
            this.scheduledAt = cache.scheduled_at || null;
            this.endsAt = cache.ends_at || null;
            // Redirect to login is handled inside checkMaintenanceMode when status !== active
        },
    },
};
</script>

<style scoped>
.maintenance-page {
    background: linear-gradient(177deg, #7963e4 50%, #172b4d calc(50% + 1px));
    color: #fff;
}

.maintenance-title {
    font-size: 2.5rem;
    font-weight: 600;
}

.maintenance-message {
    font-size: 1.15rem;
    max-width: 520px;
    margin: 0 auto;
}

.maintenance-schedule {
    color: rgba(255, 255, 255, 0.8) !important;
}
</style>
